import { postWithCsrfAjax } from './functions/utilityFunctions';

$(function () {
  $('.addCart').click(function () {
    const button = $(this)[0];
    button.disabled = true;

    const targetId = button.getAttribute('data-target');
    const target = document.getElementById(targetId);
    const snackbar = document.getElementById('js-addcart-ng');
    if (target) {
      target.classList.remove('is-active');
    }
    if (snackbar) {
      snackbar.classList.remove('is-active');
    }

    try {
      // zetaタグ関数呼び出し
      const cmdtyCode = $(this).val();
      const product = '{"sku":"' + cmdtyCode + '","quantity":1}';
      zdAddToCartAsync(product).then(() =>
        // カート追加
        postAddcart(button, target, snackbar, cmdtyCode),
      );
    } catch (error) {
      console.log(error);
      // カート追加
      postAddcart(button, target, snackbar, cmdtyCode);
    }
  });
});

/**
 * zetaタグ関数呼び出し後のカート追加API
 */
export const postAddcart = (button, target, snackbar, cmdtyCode) => {
  postWithCsrfAjax({
    url: '/api/addcart',
    type: 'POST',
    data: {
      cmdtyCode: cmdtyCode, // 送信データ
    },
    dataType: 'json',
    timespan: 1000,
  })
    // Ajax通信が成功
    .done(function (res, textStatus, jqXHR) {
      if (res.status === 'ng') {
        // カートに入れる際にエラー発生
        if (snackbar) {
          // messageをスナックバーに設定する
          snackbar.querySelector('.c-snackbar__text').innerText = res.message;
          snackbar.classList.toggle('is-active');
        }
        return;
      }
      if (target) {
        // 商品詳細の場合はモーダルに各種テキストを設定
        if (button.dataset.cartinfo) {
          // 送料
          const shippingCostStr = res.data.shippingCost === '0' ? '無料' : parseInt(res.data.shippingCost).toLocaleString() + '円';
          document.querySelector('.js-shippingfee-text').innerHTML = shippingCostStr;
          // 送料無料まであと〇円
          if (res.data.untilFreeShipping === '0') {
            document.querySelector('.js-forfreeshipping').style = 'display: none';
          } else {
            document.querySelector('.js-forfreeshipping').style = 'display: block';
            document.querySelector('.js-forfreeshipping-text').innerHTML = parseInt(res.data.untilFreeShipping).toLocaleString() + '円';
          }
          // カート内タダ本対象商品点数
          const freeBuyCount = document.querySelector('.js-freebuycount');
          if (freeBuyCount) {
            freeBuyCount.innerHTML = res.data.freeBookCount + '点';
          }
        }

        // バッジ更新
        const cartCountBadge = document.querySelector('.js-cartcount');
        if (cartCountBadge) {
          cartCountBadge.innerHTML = parseInt(cartCountBadge.innerHTML) + 1;
        } else {
          document.querySelector('.js-cartcontainer').insertAdjacentHTML(
            'beforeend',
            `
              <span class="l-header-common__nav-list__active l-header-common__nav-list__active-count js-cartcount">1</span>
              `,
          );
        }
        target.classList.toggle('is-active');

        // ボタンのクラスを追加
        button.classList.add('is-selected');
      }
    })
    // Ajax通信が失敗
    .fail(function (jqXHR, textStatus, errorThrown) {
      // TODO エラー時の処理が必要
      console.log(jqXHR.status); // HTTPステータスを表示
    })
    .always(function () {
      console.log('complete');
      button.disabled = false;
      const reloadFlg = button.dataset.reload || 'false';
      if (reloadFlg === 'true') {
        location.reload(); // 画面をリロード
      }
    });
};

// valueを取得して、モーダル内のボタンにセット
$(function () {
  $('.js-selectDelete').click(function () {
    const productId = $(this).val();
    $('#deleteCart').val(productId);
    $('#addFavorite').val(productId);
  });
});

$(function () {
  $('#deleteCart').click(function () {
    console.log($(this).val());

    try {
      // zetaタグ関数呼び出し
      const cmdtyCode = $(this).val();
      const product = '{"sku":"' + cmdtyCode + '","quantity":1}';
      zdRemoveFromCartAsync(product).then(() =>
        // カート削除
        postDeletecart(cmdtyCode),
      );
    } catch (error) {
      console.log(error);
      // カート削除
      postDeletecart(cmdtyCode);
    }
  });
});

/**
 * zetaタグ関数呼び出し後のカート削除API
 */
export const postDeletecart = (cmdtyCode) => {
  postWithCsrfAjax({
    url: '/api/deletecart',
    type: 'POST',
    data: {
      cmdtyCode: cmdtyCode, // 送信データ
    },
    dataType: 'json',
    timespan: 1000,
  })
    // Ajax通信が成功
    .done(function (data, textStatus, jqXHR) {
      // TODO カート追加成功、失敗時の処理が必要
      console.log(jqXHR.status);
    })
    // Ajax通信が失敗
    .fail(function (jqXHR, textStatus, errorThrown) {
      // TODO エラー時の処理が必要
      console.log(jqXHR.status); // HTTPステータスを表示
    })
    .always(function () {
      console.log('complete');
      location.reload(); // 画面をリロード
    });
};

/**
 * 【テスト用】商品選択ボタンの選択状態切り替え
 */
$(function () {
  $('.cart-item-button').click(function () {
    const cartItemColumn = $(this).closest('.cart-item-column');
    console.info('column: ', cartItemColumn);
    cartItemColumn.find('.selected-item').each(function () {
      $(this).removeClass('selected-item');
    });
    $(this).addClass('selected-item');
  });
});

/**
 * 複数追加用の数量選択プルダウン変更時の処理
 * 変更値をdata-cart-countに設定する
 */
$(function () {
  const prevValues = new Map();
  $('.cart-add-count-select').on('change', '[id^="add-cmdty-id-"]', function () {
    try {
      const $select = $(this);
      // selectの選択肢に付いた設定値を初期化
      $select.children().removeClass('selected-value');
      $select.children().removeAttr('data-cart-count');
      // 選択値を示す設定値を付与
      $select.find(':selected').addClass('selected-value');
      $select.find(':selected').attr('data-cart-count', $select.val());
    } catch (error) {
      console.log(error);
    }
  });
});

/**
 * 複数商品、複数点数カート追加用のボタン押下時処理
 */
$(function () {
  $('.addCartsWithCount').click(function () {
    console.log('!!!!! addCartsWithCount clicked !!!!!');
    const snackbar = document.getElementById('js-snack-common');
    if (snackbar) {
      snackbar.classList.remove('is-active');
    }
    try {
      // 商品コードと数量を取得
      // 押したボタンに紐づいた商品情報の要素を取得
      const targetCartId = $(this).data('cart-id');
      const targetCart = $(`[data-cart-id="${targetCartId}"]`);
      // まとめて追加したい商品IDのリスト
      const targetCartItems = targetCart.find('.selected-item').map(function () {
        return $(this).data('cart-item');
      });
      // まとめて追加したい商品の点数
      const targetCartItemsCount = targetCart.find('.selected-value').attr('data-cart-count');

      // カート追加用にJava側に渡すためのMapを生成
      const addCartItems = new Map();
      for (const item of targetCartItems) {
        addCartItems.set(item, targetCartItemsCount);
      }
      console.info('addCartItems: ', addCartItems);
      postaddCartsWithCount(addCartItems, snackbar);
    } catch (error) {
      console.warn(error);
    }
  });
});

/**
 * 複数商品を複数点数カートに追加する
 * @param {Map} addCartItems
 * @param {*} snackbar
 */
export const postaddCartsWithCount = (addCartItems, snackbar) => {
  console.log('!!!!! postaddCartsWithCount');
  const sendData = {
    cartItems: Object.fromEntries(addCartItems),
  };
  postWithCsrfAjax({
    url: '/api/addCartsWithCount',
    type: 'POST',
    data: JSON.stringify(sendData),
    contentType: 'application/json',
    dataType: 'json',
    timespan: 1000,
  })
    // Ajax通信が成功
    .done(function (res, textStatus, jqXHR) {
      if (res.status === 'ng') {
        // 数量変更時にエラー発生
        if (snackbar) {
          // messageをスナックバーに設定する
          snackbar.querySelector('.c-snackbar__text').innerText = res.message;
          snackbar.classList.toggle('is-active');
        }
        return;
      }
      // バッジ更新
      const cartCountBadge = document.querySelector('.js-cartcount');
      const totalProductsCount = res.data.totalProducts;
      if (cartCountBadge) {
        cartCountBadge.innerHTML = parseInt(totalProductsCount);
      } else {
        document.querySelector('.js-cartcontainer').insertAdjacentHTML(
          'beforeend',
          `
              <span class="l-header-common__nav-list__active l-header-common__nav-list__active-count js-cartcount">${totalProductsCount}</span>
              `,
        );
      }
      // スナックバーにカート追加した旨を表示する
      snackbar.querySelector('.c-snackbar__text').innerText = `${res.message}点の商品をカートに追加しました。`;
      snackbar.classList.toggle('is-active');

      console.info('=========== success ===========');
      console.info('res: ', res);
      console.info('textStatus: ', textStatus);
      console.info('jqXHR: ', jqXHR);
      console.info('===============================');
    })
    // Ajax通信が失敗
    .fail(function (jqXHR, textStatus, errorThrown) {
      // HTTPステータスを表示
      console.warn(jqXHR.status);
    });
};

/**
 * カート画面の数量プルダウン変更時の処理
 */
$(function () {
  const prevValues = new Map();
  $('.l-purchase-cart__product-container')
    .on('mousedown touchstart', '[id^="product-count-"]', function () {
      const id = $(this).attr('id');
      prevValues.set(id, $(this).val());
    })
    .on('change', '[id^="product-count-"]', function () {
      const $select = $(this);
      const id = $select.attr('id');
      const cmdtyCode = id.split('-')[2];
      const newAmount = $select.val();
      const prevAmount = prevValues.get(id);
      const snackbar = document.getElementById('js-snack-common');
      if (snackbar) {
        snackbar.classList.remove('is-active');
      }

      try {
        postUpdateAmount($select, cmdtyCode, newAmount, prevAmount, snackbar);
      } catch (error) {
        console.log(error);
      }
    });
});

/**
 * 数量変更APIを呼び出す
 */
export const postUpdateAmount = ($select, cmdtyCode, amount, prevAmount, snackbar) => {
  $select.prop('disabled', true);

  postWithCsrfAjax({
    url: '/api/updateAmount',
    type: 'POST',
    data: {
      cmdtyCode: cmdtyCode,
      amount: amount,
    },
    dataType: 'json',
    timespan: 1000,
  })
    // Ajax通信が成功
    .done(function (res, textStatus, jqXHR) {
      if (res.status === 'ng') {
        // 数量変更時にエラー発生
        if (snackbar) {
          // messageをスナックバーに設定する
          snackbar.querySelector('.c-snackbar__text').innerText = res.message;
          snackbar.classList.toggle('is-active');
          $select.val(prevAmount);
        }
        return;
      }
      // 数量変更に成功した場合は画面をリロードする
      location.reload();
    })
    // Ajax通信が失敗
    .fail(function (jqXHR, textStatus, errorThrown) {
      // HTTPステータスを表示
      console.warn(jqXHR.status);
      $select.val(prevAmount);
    })
    .always(function () {
      $select.prop('disabled', false);
    });
};
